import { render } from "./TemplateCPN.vue?vue&type=template&id=e8e65748"
import script from "./TemplateCPN.vue?vue&type=script&lang=js"
export * from "./TemplateCPN.vue?vue&type=script&lang=js"
script.render = render

export default script